import types from "./types";
import storage from "../helpers/storage";

export default () => dispatch => {
  dispatch({
    type: types("logout").fulfilled
  });
  storage.remove("payload");
};
